export function getStickerImageId(sticker) {
  if (!sticker) return null;
  if (typeof sticker === "string") return sticker;

  if (sticker.sticker_image?.imageId) return sticker.sticker_image.imageId;
  if (sticker.sticker_image?.image_id) return sticker.sticker_image.image_id;
  if (sticker.sticker_media?.imageId) return sticker.sticker_media.imageId;
  if (sticker.sticker_media?.image_id) return sticker.sticker_media.image_id;
  if (sticker.media?.imageId) return sticker.media.imageId;
  if (sticker.media?.image_id) return sticker.media.image_id;
  if (sticker.image?.imageId) return sticker.image.imageId;
  if (sticker.image?.image_id) return sticker.image.image_id;
  if (sticker.imageId) return sticker.imageId;
  if (sticker.image_id) return sticker.image_id;
  if (typeof sticker.sticker_image === "string") return sticker.sticker_image;
  if (typeof sticker.image === "string") return sticker.image;

  return null;
}

export function getStickerId(sticker) {
  if (!sticker) return null;
  return (
    sticker._id ||
    sticker.id ||
    sticker.sticker_id ||
    sticker.stickerId ||
    getStickerImageId(sticker)
  );
}
